import { render, staticRenderFns } from "./ViewProductDesign.vue?vue&type=template&id=ba076cdc&scoped=true"
import script from "./ViewProductDesign.vue?vue&type=script&lang=js"
export * from "./ViewProductDesign.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./ViewProductDesign.vue?vue&type=style&index=0&id=ba076cdc&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "ba076cdc",
  null
  ,true
)

export default component.exports